import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import Hero from "./home/Hero";
import Services from "./home/Services";
import ProjectsPreview from "./home/ProjectsPreview";
import ReviewsSection from "./home/ReviewsSection";
import Marquee from "../components/Marquee";
import UrgentSection from "../components/UrgentSection";
import ContactSection from "../components/ContactSection";
import { Intro, WhyUs, Process, AboutTeaser, ServiceAreas } from "./home/Sections";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => {
        document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <>
      <Seo
        title="Builders Wellington | Renovations & New Builds | Razor Build"
        description="Licensed Wellington builders with 10+ years' experience. Home renovations, alterations, extensions and new builds across Wellington, Hutt Valley and Porirua — plus smaller building jobs and urgent repairs."
      />
      <Hero />
      <Intro />
      <Services />
      <Marquee items={["Renovations", "Extensions", "New Builds", "Build • Renovate • Maintain"]} />
      <ProjectsPreview />
      <WhyUs />
      <Process />
      <UrgentSection />
      <AboutTeaser />
      <ReviewsSection />
      <ServiceAreas />
      <ContactSection />
    </>
  );
}
